import { useMutation } from 'react-query';
import { albumRequest } from 'src/models/gallery';
import { addAlbumPhotos} from 'src/services/gallery';

export default function useAddAlbumPhotos(
  id: number
) {
  return useMutation((data: { image: File[] }) => addAlbumPhotos(data, id));
}
